//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SingleMobileMarket from '~/components/detail/desktop/single_mobile_market'
import SingleLoading from '~/components/partials/loading/single_loading'
export default {
  name: 'CoinsList',
  components: { SingleLoading, SingleMobileMarket },
  data () {
    return {
      markets: null,
      loading: false
    }
  },
  created () {
    this.getMarkets()
  },
  methods: {
    getMarkets () {
      this.$store.dispatch('axios/get', { url: '/market/list', config: { baseURL: process.env.BASE_EXCHANGE_URL } })
        .then((res) => {
          this.markets = res.data.data.markets
        }).catch((e) => {
          return e
        })
    }
  }
}
